import { Editor } from "@tinymce/tinymce-react";
export const TinyEditor = ({ value, setValue, plugins, toolbar, functions }) => {
  return (
    <Editor
      apiKey="mnodxl94kkk4k55xgt1dwm7rwmir6znxrvk4118z6bne1epe"
      value={value}
      init={{
        height: 500,
        selector: "textarea",
        menubar: false,
        plugins: plugins,
        toolbar: toolbar,
        setup: functions,
      }}
      onEditorChange={(newText) => setValue(newText)}
    />
  );
};

export default TinyEditor;
